import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

/**
 * KI-Chat-Icon: Sprechblase mit drei Punkten, der Vier-Punkt-Funke sitzt
 * außen an der oberen rechten Ecke — nach der Icon-Vorlage aus dem Branding.
 */
const AiChatIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Sprechblase mit Schweif */}
    <path
      d="M5.7 6.8h9.5c1.55 0 2.8 1.25 2.8 2.8v4c0 1.55-1.25 2.8-2.8 2.8H9.8l-3.4 2.9c-.33.28-.84.05-.84-.39v-2.51h-.06c-1.55 0-2.8-1.25-2.8-2.8v-4c0-1.55 1.25-2.8 2.8-2.8Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    {/* drei Punkte */}
    <circle cx="7.4" cy="11.6" r="1.1" fill="currentColor" />
    <circle cx="10.45" cy="11.6" r="1.1" fill="currentColor" />
    <circle cx="13.5" cy="11.6" r="1.1" fill="currentColor" />
    {/* Funke außen an der oberen Ecke */}
    <path
      d="M19.7 1.2c.2 1.18.47 1.84.89 2.24.42.4 1.1.64 2.28.82-1.18.18-1.86.42-2.28.82-.42.4-.69 1.06-.89 2.24-.2-1.18-.47-1.84-.89-2.24-.42-.4-1.1-.64-2.28-.82 1.18-.18 1.86-.42 2.28-.82.42-.4.69-1.06.89-2.24Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default AiChatIcon;
